import styled from "styled-components";

import * as colors from "src/styles/constants/colors";

type SelectableColumnProps = {
  isSelectColumn?: boolean;
  isSelected?: boolean;
};

export const StyledTable = styled.table`
  width: 100%;
  border-collapse: collapse;
  font-size: 14px;
  border: 1px solid #e0e0e0;
`;

export const StyledTh = styled.th<SelectableColumnProps>`
  text-align: left;
  border-bottom: 1px solid #e0e0e0;
  border-right: 1px solid #e0e0e0;
  padding: 8px;
  background: #fafafa;
  font-weight: 500;
  color: #667085;
  ${({ isSelectColumn }) =>
    isSelectColumn &&
    `
    width: 48px;
    text-align: center;
    padding: 8px 4px;
  `}
`;

export const StyledTr = styled.tr<SelectableColumnProps>`
  ${({ isSelected }) =>
    isSelected &&
    `
    background-color: #f0f7ff;
  `}
`;

export const StyledTd = styled.td<SelectableColumnProps>`
  border-bottom: 1px solid #e0e0e0;
  border-right: 1px solid #e0e0e0;
  padding: 8px;
  vertical-align: top;
  ${({ isSelectColumn }) =>
    isSelectColumn &&
    `
    width: 48px;
    text-align: center;
    padding: 8px 4px;
  `}
`;

export const CheckboxWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const StyledTbody = styled.tbody`
  background-color: ${colors.brightLight};
`;
